/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable consistent-return */
export const SearchProductAndSubCategory = (data: any, search: string) => {
  if (data.menu?.categorias?.length > 0) {
    const dataProducts = [];
    const dataSubCategories = [];
    for (let index = 0; index < data.menu?.categorias?.length; index += 1) {
      const categorias = data.menu.categorias[index];
      for (
        let iProduct = 0;
        iProduct < categorias.produtos.length;
        iProduct += 1
      ) {
        const product = categorias.produtos[iProduct];
        const desSearch = search.toUpperCase();
        if (product?.dsNome.toUpperCase().indexOf(desSearch) > -1) {
          product.idCategoria = categorias.idCategoria;
          dataProducts.push(product);
        }
      }

      for (
        let iSubCategorie = 0;
        iSubCategorie < categorias.subcategorias.length;
        iSubCategorie += 1
      ) {
        const subCategorie = categorias.subcategorias[iSubCategorie];
        const desSearch = search.toUpperCase();
        if (
          subCategorie?.dsSubCategoria.toUpperCase().indexOf(desSearch) > -1
        ) {
          subCategorie.idCategoria = categorias.idCategoria;
          dataSubCategories.push(subCategorie);
        }
      }
    }
    return { dataProducts, dataSubCategories };
  }
};
